import {stringify} from 'qs'
import api from 'crm/common/api/group-list'
import request from 'utils/request'
import {format} from '@/utils'

export async function getGroupList(payload) {
    return request(api.getGroupList.url, {
        method: api.getGroupList.type,
        body: payload.body,
    })
}

export async function getGroupOwnerList(payload) {
    return request(`${api.getGroupOwnerList.url}?${stringify(payload)}`)
}
export async function editGroupInfo(payload) {
    return request(`${format(api.editGroupInfo.url, {id: payload.id})}`, {
        method: api.editGroupInfo.type,
        body: payload.body,
    })
}

// 获取群成员
export async function getGroupMembers(payload) {
    return request(
        `${format(api.getGroupMembers.url, {id: payload.id})}?${stringify(payload.params)}`,
    )
}

// 获取群详情
export async function getGroupDetails(payload) {
    return request(`${format(api.getGroupDetails.url, {id: payload.id})}`)
}

// 获取群中的统计
export async function getGroupStat(payload) {
    return request(`${format(api.getGroupStat.url, {id: payload.id})}`)
}

export async function downloadTemplate() {
    return request(`${api.downloadTemplate.url}?t=${new Date().getTime()}`, null, {
        returnResponse: true,
    })
}

export async function importGroupLink(payload) {
    return request(api.importGroupLink.url, {
        method: api.importGroupLink.type,
        body: payload.body,
    })
}

export async function communityQrcode(payload) {
    return request(`${api.communityQrcode.url}?${stringify(payload)}`)
}

export async function tasks(payload) {
    return request(`${format(api.tasks.url, {task_id: payload.task_id})}`)
}

export async function exportListData(payload) {
    console.log('exportListData', payload)
    return request(api.exportListData.url, {
        method: api.exportListData.type,
        body: payload,
    })
}
